// extracted by mini-css-extract-plugin
export default {"value":"ModelFactors_value__CglaP","wrapper":"ModelFactors_wrapper__wGW6+"};